import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-hero-especialidades',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: '../../hero-global/hero-global.component.html',
  styleUrl: './hero-especialidades.component.css'
})
export class HeroEspecialidadesComponent {
  namePage='Especialidades';
  linkPage='/especialidades';

}
